import { InlineTextButtonStyled } from './styles/InlineTextButtonStyled'

export const InlineTextButton = InlineTextButtonStyled

InlineTextButton.displayName = 'InlineTextButton'
